<section class="border-b border-light-grey p-2">
  <div>
    <div class="w-full flex justify-between items-center">
      <div class="flex flex-col">
        <span class="font-medium leading-6">{{ weightItem().weight }} kg</span>
        <span class="text-mid-grey leading-6">{{ weightItem().date | dayjsFormat: 'date' }}</span>
      </div>

      <app-button
        variant="secondary"
        text="bearbeiten"
        [small]="true"
        (clicked)="clicked.emit()"
      />
    </div>
  </div>
</section>
